module.exports = __webpack_public_path__ + "static/media/Einzelstunden01.ebf538da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Einzelstunden01.jpg
// module id = 337
// module chunks = 0